import { readCookie } from './readCookie';
const categoryCodes = ['C0001', 'C0002', 'C0004'];
const categoryNameToCodeMap = {
    essential: 'C0001',
    analytics: 'C0002',
    marketing: 'C0004',
};
const categoryCodeToNameMap = Object.entries(categoryNameToCodeMap).reduce((accum, entry) => {
    const name = entry[0];
    const code = entry[1];
    accum[code] = name;
    return accum;
}, {});
const readCookieCategoriesFromCookie = () => {
    const optanonConsent = readCookie('OptanonConsent');
    const groups = new URLSearchParams(optanonConsent).get('groups') || '';
    const activeCodes = groups
        .split(',')
        .map((group) => group.split(':'))
        .filter(([groupCode]) => !!groupCode)
        .filter(([, isConsented]) => isConsented === '1')
        .map(([groupCode]) => groupCode);
    return activeCodes;
};
export const getActiveCategoryCodes = () => {
    const activeGroups = (typeof window !== 'undefined' ? window.OnetrustActiveGroups : '') || '';
    const liveActiveCodes = activeGroups.split(/\s*,\s*/).filter(Boolean);
    const activeCodes = liveActiveCodes.length > 0
        ? liveActiveCodes
        : readCookieCategoriesFromCookie();
    return [...new Set(['C0001', ...activeCodes])].sort();
};
export const readCookieCategories = () => {
    const activeCodes = getActiveCategoryCodes();
    const byCode = categoryCodes.reduce((accum, catCode) => {
        accum[catCode] = activeCodes.includes(catCode);
        return accum;
    }, {});
    const byName = Object.entries(byCode).reduce((accum, [categoryCode, isActive]) => {
        const categoryName = categoryCodeToNameMap[categoryCode];
        accum[categoryName] = isActive;
        return accum;
    }, {});
    return { byCode, byName };
};
export const canWriteCookieCategory = (category) => {
    if (category === 'essential') {
        return true;
    }
    const cookieCategories = readCookieCategories();
    return !!cookieCategories.byName[category];
};
//# sourceMappingURL=categories.js.map
// @zapier/cookies@1.1.3 (39d1b5f07)
